import "./error.css";

export default function ErrorScreen() {
  return (
    <div className="error-screen">
      <div className="error-box">
        <h1>Failed to load the 3D model</h1>
        <p>Something went wrong while loading the avatar. Please try again.</p>
        <button
          onClick={() => window.location.reload()}
          className="reload-button"
        >
          Try again
        </button>
      </div>
    </div>
  );
}
